/*
 * SelectRecipients Messages
 *
 * This contains all the text for the SelectRecipients component.
 */
import { defineMessages } from 'react-intl';

import memberMessages from 'components/GroupLists/MemberLists/messages.js';

const ownMessages = defineMessages({
  noUsers: {
    id: 'app.components.SelectRecipients.noUsers',
    defaultMessage: 'No users found',
  },
  employee: {
    id: 'app.components.UsersByRole.employee',
    defaultMessage: 'Employees',
  },
  parent: {
    id: 'app.components.UsersByRole.parent',
    defaultMessage: 'Parents',
  },
  student: {
    id: 'app.components.UsersByRole.student',
    defaultMessage: 'Students',
  },
  staff: {
    id: 'app.components.UsersByRole.staff',
    defaultMessage: 'Students',
  },
  classes: {
    id: 'app.components.SideMenu.classes',
    defaultMessage: 'Classes',
  },
  general: {
    id: 'app.components.AdminGroups.general',
    defaultMessage: 'General Group',
  },
  inboxes: {
    id: 'app.components.UsersByRole.inboxes',
    defaultMessage: 'Inboxes',
  },
  adminGroups: {
    id: 'app.components.AdminGroups.adminGroups',
    defaultMessage: 'Administrative Groups',
  },
  save: {
    id: 'app.common.save',
    defaultMessage: 'Save',
  },
  prompt: {
    id: 'app.components.SelectUsers.prompt',
    defaultMessage: 'Select users',
  },
  atLeastOne: {
    id: 'app.components.SelectUsers.atLeastOne',
    defaultMessage: 'Select at least one user',
  },
});

export default { ...memberMessages, ...ownMessages };
